import { ExperimentName } from './experiments';

function isExperimentName(value: string): value is ExperimentName {
  return Object.values(ExperimentName).includes(value as ExperimentName);
}

/**
 * Converts a string to the corresponding ExperimentName enum value using Object.values.
 * Returns undefined if the string does not match any ExperimentName.
 *
 * @param name - The string to convert.
 * @returns The corresponding ExperimentName enum value or undefined.
 */
export function convertToExperimentName(name: string): ExperimentName | undefined {
  return isExperimentName(name) ? name : undefined;
}

/**
 * Creates experiment props for analytics tracking, converting string experiment names to enum values.
 * If the experiment name doesn't match any enum value, uses ExperimentName.Untyped as fallback
 * and preserves the original string in untyped_experiment_name.
 *
 * @param rawExperimentName - The raw experiment name string from the API.
 * @returns Props object with typed experiment_name and optional untyped_experiment_name.
 */
export function createExperimentProps(rawExperimentName: string) {
  const convertedExperimentName = convertToExperimentName(rawExperimentName);
  return convertedExperimentName
    ? { experiment_name: convertedExperimentName }
    : {
        experiment_name: ExperimentName.Untyped,
        untyped_experiment_name: rawExperimentName,
      };
}
